import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import HomeScreen from './home';
import BuffetScreen from './buffet';
import CumpleScreen from './cumple';
import { useSelector } from 'react-redux';


function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showHome, setShowHome] = useState(false);
    const [homeMode, setHomeMode] = useState(1);
    const [showBuffet, setShowBuffet] = useState(false);
    const [showCumple, setShowCumple] = useState(false);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);
    
     const {
           goHomeInit
     } = useSelector((state) => state.initLoad);
    
     useEffect(() => {
     
         setShowHome(false);
         }, [goHomeInit]);

    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);



      useEffect(() => {
              menus.map((item) => {
                  if (item.id === 435) {
                  setDataFood(item);
                  }
             
             
              });
      }, [menus]);
    
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowHome(false)

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);



    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };


    return (
       
        <LayoutContent showLang={false} showFooter={false} showBack={false} showImageTop={true} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
            <div>
                <div style={{ width: '100%' }}>
                   
                    <div style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: "center"
                    }}>

                        <img
                         onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 280,
                            height: 170,
                             pointerEvents: 'none',
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 30,
                             marginBottom: 50
                            
                        }}
                        src={require('./assets/welcometo.png')}
                    />
                        
                         <img
                         onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: 312,
                            height: 170,
                             pointerEvents: 'none',
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: 30,
                            marginBottom: 50
                            
                        }}
                        src={require('./assets/logo2.png')}
                    />
                   </div>
                     
                </div>
                <div style={{}}>

                    <img
                            onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/home2.png')}
                            loop autoPlay={true} muted
                            onClick={() => { setHomeMode(2); i18next.changeLanguage('en'); setShowHome(true); }}
                            style={{
                                width: '100%',
                                height:290,
                                objectFit: 'contain',
                                borderRadius: 14,
                                cursor: 'pointer',
                            }}
                    />
                     <img
                            onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/divider.png')}
                            loop autoPlay={true} muted
                           
                            style={{
                                marginTop: 20,
                                marginBottom: 20,
                                width: '100%',
                                height:30,
                                objectFit: 'contain',
                                borderRadius: 14,
                                cursor: 'pointer',
                            }}
                    />

                    <img
                            onContextMenu={(e) => e.preventDefault()}
                            src={require('./assets/home1.png')}
                            loop autoPlay={true} muted
                            onClick={() => { setHomeMode(1); i18next.changeLanguage('es'); setShowHome(true); }}
                            style={{
                                marginTop: 10,
                                width: '100%',
                                height:290,
                                objectFit: 'contain',
                                borderRadius: 14,
                                cursor: 'pointer',
                            }}
                    />

                    
               </div>
                
                 
               
            </div>

            {showBuffet && <BuffetScreen setShowBuffet={setShowBuffet} />}
            {showCumple && <CumpleScreen setShowBuffet={setShowCumple} />}
            {showHome && <HomeScreen setShowBar={setShowBar} homeMode={homeMode} />}
            </LayoutContent>
           
    );
}

export default Index;